export class Filter {
    constructor(filterProperty, name) {
        this.filterProperty = filterProperty;
        this.name = name;
    }
    setOnChange(onChange) {
        this.onChange = onChange;
    }
}
